import IsibuteDocumentComponent from "./IsibuteDocumentComponent";
import { documentComponentFromData } from "./DocumentComponentRegistry";

class IsibuteDocumentUnorderedList extends IsibuteDocumentComponent {
  constructor({
    id,
    documentUnorderedListItems,
    unstyledContent,
    styling,
    ordinal,
    documentComponentType,
    parentDocumentComponentId,
    firstChildDocumentComponentId,
    lastChildDocumentComponentId,
    previousDocumentComponentId,
    nextDocumentComponentId,
    isibuteDocument,
  }) {
    super({
      id,
      unstyledContent,
      styling,
      ordinal,
      documentComponentType,
      parentDocumentComponentId,
      firstChildDocumentComponentId,
      lastChildDocumentComponentId,
      previousDocumentComponentId,
      nextDocumentComponentId,
      isibuteDocument,
    });

    this.documentUnorderedListItems = {};

    if (documentUnorderedListItems) {
      Object.entries(documentUnorderedListItems).forEach(([key, value]) => {
        this.documentUnorderedListItems[key] = documentComponentFromData({ ...value, isibuteDocument });
      });
    }
  }

  asJSON = () => {
    return {
      id: this.id,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
      documentUnorderedListItems: Object.values(this.documentUnorderedListItems).map((documentComponent) => {
        return documentComponent.asJSON();
      }),
    }
  }

  deepCopy = () => {
    const copy = new this.constructor({
      id: this.id,
      unstyledContent: this.unstyledContent,
      styling: this.styling,
      ordinal: this.ordinal,
      documentComponentType: this.documentComponentType,
      parentDocumentComponentId: this.parentDocumentComponentId,
      firstChildDocumentComponentId: this.firstChildDocumentComponentId,
      lastChildDocumentComponentId: this.lastChildDocumentComponentId,
      previousDocumentComponentId: this.previousDocumentComponentId,
      nextDocumentComponentId: this.nextDocumentComponentId,
      isibuteDocument: this.isibuteDocument,
    });

    Object.entries(this.documentUnorderedListItems).forEach(([key, value]) => {
      copy.documentUnorderedListItems[key] = value.deepCopy();
    });

    return copy;
  };

  getDocumentComponentByKey = (key) => {
    return this.documentUnorderedListItems[key] || null;
  };

  getDocumentComponentByKeyPath = ({ keyPath }) => {
    const [first, ...rest] = keyPath ?? [];
    const currentDocumentComponent = this.getDocumentComponentByKey(first);

    if (rest.length > 0) {
      return currentDocumentComponent?.getDocumentComponentByKeyPath({ keyPath: rest }) || null;
    }

    return currentDocumentComponent;
  };
};

export default IsibuteDocumentUnorderedList;
